import {FC} from 'react';
import {HivesRow} from './types';
import {TableMobileIcon, TableMobileItem, TableMobileWrapper} from './styles';
import {ArrowRight} from 'shared/ui/icons/arrowRight.tsx';
import {HiveIcon} from 'shared/ui/icons/hiveIcon.tsx';
import {formatDistanceToNowStrict} from 'date-fns';
import {ru} from 'date-fns/locale';

type Props = {rows: HivesRow[]; onRowClick: (row: HivesRow) => void};

export const HivesMobileTable: FC<Props> = ({rows, onRowClick}) => {
  return (
    <TableMobileWrapper>
      {rows.length
        ? rows.map((el) => (
            <TableMobileItem
              key={el.id}
              onClick={() => {
                if (el.deletedAt) return;
                onRowClick(el);
              }}
              style={{
                cursor: el.deletedAt ? 'not-allowed' : 'pointer',
                opacity: el.deletedAt ? 0.5 : 1,
              }}
            >
              <i>
                <HiveIcon />
              </i>
              <div>
                Улей №{el.number} • {el.devices || '—'}
              </div>
              <span>
                Обновлено{' '}
                {formatDistanceToNowStrict(el.updatedAt, {
                  locale: ru,
                  addSuffix: true,
                })}
              </span>
              <TableMobileIcon>
                <ArrowRight />
              </TableMobileIcon>
            </TableMobileItem>
          ))
        : 'Не найдено ульев по заданным параметрам'}
    </TableMobileWrapper>
  );
};
